module.exports = __webpack_public_path__ + "static/media/R-PANELv6.5-RC1/lead_error_UBPE.4bde5110.svg";